import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CircleHourglassIcon = ({
  color = 'black',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg
      width={Number(width)}
      height={Number(width)}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          id="union"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21ZM11 19.5C15.6944 19.5 19.5 15.6944 19.5 11C19.5 6.30558 15.6944 2.5 11 2.5C6.30558 2.5 2.5 6.30558 2.5 11C2.5 15.6944 6.30558 19.5 11 19.5ZM11.3795 10.5C11.4186 10.3728 11.473 10.2491 11.5427 10.1318L12.5175 8.2001L9.48243 8.2001L10.4571 10.1319C10.5268 10.2492 10.5813 10.3728 10.6204 10.5H11.3795ZM9.40994 10.7203C9.52404 10.8894 9.52404 11.1108 9.40994 11.2798L7.92633 14.2203C7.70218 14.5523 7.9401 15 8.34075 15L13.6592 15C14.0599 15 14.2978 14.5523 14.0737 14.2203L12.5899 11.2798C12.4758 11.1107 12.4758 10.8893 12.5899 10.7203L14.0736 7.77984C14.2978 7.44776 14.0599 7.0001 13.6592 7.0001L8.34072 7.0001C7.94007 7.0001 7.70214 7.44776 7.92629 7.77984L9.40994 10.7203Z"
          fill={getSemanticTextColor(color)}
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
